import { Card, Col, Flex, Progress, Row } from 'antd';
import React from 'react';
import './App.css';

const conicColors = {
    '0%': '#ffccc7',
    '50%': '#ffe58f',
    '100%': '#87d068',
};

const ReportComponent = () => {


    var resumeReport = JSON.parse(localStorage.getItem('resumeData'));




    return (
        <div  className='report-container'>
            {/* <h1>Resume Report</h1> */}
            <Row gutter={[16, 16]}>

                <Col xs={{span:24, order: 2}} md={{span:17, order: 2}} style={{ marginRight: 10 }} >
                    <Card title="Overall Review" bordered={false} style={{ marginBottom: '10px' }}>
                        {resumeReport.overall_summary}
                    </Card>

                    <Card title="Garmmar Checks" bordered={false} style={{ marginBottom: '10px' }}>
                        {resumeReport.grammar_check.map((item, index) => {
                            return (
                                <Card bordered={true} style={{ borderLeft: '2px solid red', marginBottom: '5px' }}>
                                    <div style={{display: 'flex', alignItems: 'center'}}> 
                                        {/* <div className='numberCircle'>
                                            {index + 1}
                                        </div> */}
                                        
                                        <div>
                                            <div >

                                                <span style={{ fontWeight: 500 }}>{item.error}</span>

                                            </div>
                                            <span>Suggestion : <span className='light-grey-text'>{item.correction}</span></span>
                                        </div>
                                    </div>
                                </Card>
                            )
                        })}
                    </Card>

                    <Card title="Need Improvements" bordered={false} style={{ marginBottom: '10px' }}>
                        {resumeReport.need_improvements.map((item, index) => {
                            return (
                                <Card bordered={true} title={item.area} style={{ marginBottom: '5px' }}>
                                    <div > 
                                        
                                        <div>
                                            <strong>Feedback:</strong> {item.feedback}
                                        </div>
                                        <div>
                                            <strong>Suggestion: <ul>
                                                {item.suggestions.map((suggestion, index) => {
                                                    return (
                                                        <li key={index} style={{fontWeight:400}} className='light-grey-text'>{suggestion}</li>
                                                    )
                                                })}
                                                </ul></strong>
                                        </div>
                                        {/* <div>
                                            <div >

                                                <span style={{ fontWeight: 500 }}>{item.error}</span>

                                            </div>
                                            <span>Suggestion : <span className='light-grey-text'>{item.correction}</span></span>
                                        </div> */}
                                    </div>
                                </Card>
                            )
                        })}
                    </Card>
                </Col>
                <Col xs={{span:24, order: 1}}  md={{span:6, order: 1}} style={{ textAlign: 'center' }}>
                    <Card title="Resume Score" bordered={false}>
                        <div>
                            <Flex gap="small" vertical>
                                <Progress type="dashboard" percent={resumeReport.resume_score} strokeColor={conicColors} />
                            </Flex>
                            <span className='light-grey-text'>You resume scored {resumeReport.resume_score} out of 100</span>
                        </div>
                    </Card>

                </Col>
            </Row>
        </div>
    );
}

export default ReportComponent;